import { render, staticRenderFns } from "./DinamicClass.vue?vue&type=template&id=1a58bebc"
import script from "./DinamicClass.vue?vue&type=script&lang=js"
export * from "./DinamicClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports